export const RouteNames = {
  HOME: '/',
  PROJECT_SITE_HOME: '/:projectId/:siteId',
  LOGIN: '/login',
  AZURE_CALLBACK: '/public/oauth',
  CIAM_CALLBACK: '/public/coauth',
  NOT_FOUND: '*',

  // Dashboard routes with project and site context
  DASHBOARD_STORAGE: '/:projectId/:siteId/dashboard/storage-overview',
  DASHBOARD_TRANSPORT: '/:projectId/:siteId/dashboard/transport-overview',
  DASHBOARD_SERVICE_USERS: '/:projectId/:siteId/dashboard/service-users',
  DASHBOARD_MAPPING: '/:projectId/:siteId/dashboard/mapping',

  CONSIGNMENTS: '/:projectId/:siteId/requests',
  CONSIGNMENT_NEW: '/:projectId/:siteId/consignments/new',
  CONSIGNMENT_EDIT: '/:projectId/:siteId/consignments/:consignmentId/edit',
  SERVICE_REQUESTS: '/:projectId/:siteId/service-requests'
} as const;

export type RouteNames = (typeof RouteNames)[keyof typeof RouteNames];
